import { FaSpinner } from "react-icons/fa";
import { cn } from "@/lib/utils";

interface PageLoaderProps {
  /** Screen-reader label only; no visible loading text. */
  label?: string;
  className?: string;
}

export function PageLoader({ label = "Cargando...", className }: PageLoaderProps) {
  return (
    <div
      className={cn("flex items-center justify-center py-16", className)}
      role="status"
      aria-live="polite"
      aria-busy="true"
      aria-label={label}
    >
      <FaSpinner className="h-8 w-8 animate-spin text-soccer-primary" />
      <span className="sr-only">{label}</span>
    </div>
  );
}
